module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-ea9c0b.be3cd982.png";